/* eslint-disable no-unused-vars */
import { defineStore } from "pinia";
import http from "../config/apiConfig";

export const useJ7Store = defineStore("j7", {
    actions: {
        async j7SummaryFetch(payload) {
            const body = {
                groupUid: payload.groupUid,
                shopUid: payload.shopUid,
                year: payload.year,
                month: payload.month // 1-12
            };
            return new Promise((resolve, reject) => {
                try {
                    const pathUrl = "/pawn-rpt-svc/j7/sum";
                    const response = http.post(pathUrl, body);
                    resolve(response);
                } catch (e) {
                    reject(e);
                }
            });
        },
    },
});